<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps({
  collapse: {
    type: Boolean,
    default: false,
    required: false
  },
  customizeError: {
    type: Boolean,
    default: false,
    required: false
  },
  state: {
    type: String,
    default: 'done',
    required: false,
    validator: (value: string) => {
      return ['none', 'done', 'loading', 'empty', 'error'].includes(value)
    }
  },
  topPage: {
    type: Boolean,
    default: false,
    required: false
  }
})

const stateComp = computed(() => props.state)

const collpaseRef = computed(() => props.collapse)
const customizeErrorComp = computed(() => props.customizeError)

const emit = defineEmits(['retry'])
</script>
<template>
  <div flex flex-col items-center>
    <div
      relative
      w-full
      :class="[collpaseRef ? 'md:max-w-screen-xl' : 'md:max-w-2xl lg:max-w-3xl', props.topPage ? 'mt-10 md:mt-4' : '']">
      <slot name="header"></slot>
      <!-- inner layout -->
      <div v-if="stateComp == 'done'" :class="{ 'fade-in': stateComp == 'done' }" flex="~ col" items-start>
        <slot></slot>
      </div>
      <div v-if="stateComp == 'loading'" w-full>
        <slot name="skeleton"></slot>
      </div>
      <div v-if="stateComp == 'empty'" w-full>
        <slot name="empty"></slot>
      </div>
      <div v-if="stateComp == 'error'" w-full>
        <slot v-if="customizeErrorComp" name="error"></slot>
        <ErrorView v-if="!customizeErrorComp" :msg="$t('alt.just_failed')">
          <button btn-solid mt-4 @click="$emit('retry')">{{ $t('action.reload') }}</button>
        </ErrorView>
      </div>

      <slot name="fullscreen"></slot>
    </div>
  </div>
</template>
<style lang="scss" scoped>
@supports (bottom: constant(safe-area-inset-bottom)) or (bottom: env(safe-area-inset-bottom)) {
  .safe-padding {
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
    padding-top: 0.45rem;
    transition: padding-bottom 0.3s ease;
  }
}

@keyframes fadeIn {
  from {
    /* 动画开始时 */
    opacity: 0;
    /* 透明度为0 */
  }

  to {
    /* 动画结束时 */
    opacity: 1;
    /* 透明度为1 */
  }
}

// @keyframes fadeOut {
//     from { /* 动画开始时 */
//         opacity: 1; /* 透明度为0 */
//     }
//     to { /* 动画结束时 */
//         opacity: 0; /* 透明度为1 */
//     }
// }

/* 应用动画 */
.fade-in {
  animation: fadeIn 0.6s ease forwards;
  /* 动画名称，持续时间，缓动函数，填充模式 */
}

// .fade-out {
//     animation: fadeOut 0.5s ease forwards; /* 动画名称，持续时间，缓动函数，填充模式 */
// }
</style>
